import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-234e3050"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Details", -1))
const _hoisted_4 = { class: "info-wrapper" }
const _hoisted_5 = {
  key: 1,
  class: "display-custom-field"
}
const _hoisted_6 = { class: "custom-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Anzahl Gesamt", -1))
const _hoisted_8 = { class: "custom-field" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Art des Auftrags", -1))
const _hoisted_10 = { class: "custom-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Deadline der Lieferung", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Tags", -1))
const _hoisted_13 = { class: "sections" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "section-body"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_indicator_circular = _resolveComponent("md-progress-indicator-circular")!
  const _component_transition_fade = _resolveComponent("transition-fade")!
  const _component_md_avatar = _resolveComponent("md-avatar")!
  const _component_md_menu = _resolveComponent("md-menu")!
  const _component_md_progress_indicator_linear = _resolveComponent("md-progress-indicator-linear")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_details_tags = _resolveComponent("details-tags")!
  const _component_md_content_editable = _resolveComponent("md-content-editable")!
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_checkbox = _resolveComponent("md-checkbox")!
  const _component_md_select = _resolveComponent("md-select")!
  const _component_details_link_field = _resolveComponent("details-link-field")!
  const _component_details_file_field = _resolveComponent("details-file-field")!
  const _directive_v_on_click_outside = _resolveDirective("v-on-click-outside")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "details",
    ref: "details",
    onClick: _cache[6] || (_cache[6] = ($event: any) => (this.focused = true))
  }, [
    _createVNode(_component_transition_fade, null, {
      default: _withCtx(() => [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(_component_md_progress_indicator_circular, { size: "large" })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.conversation && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.currentOperator)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "operator",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.chooseOperatorActive = !_ctx.chooseOperatorActive), ["stop"]))
                }, [
                  _createVNode(_component_md_avatar, {
                    variant: "monogram",
                    raw: _ctx.currentOperator.name,
                    size: "small"
                  }, null, 8, ["raw"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.currentOperator.name), 1),
                  (_ctx.chooseOperatorActive)
                    ? (_openBlock(), _createBlock(_component_md_menu, {
                        key: 0,
                        small: "",
                        items: _ctx.operatorItems,
                        onSelect: _ctx.onSelectOperator
                      }, null, 8, ["items", "onSelect"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_transition_fade, null, {
              default: _withCtx(() => [
                (_ctx.processing)
                  ? (_openBlock(), _createBlock(_component_md_progress_indicator_linear, {
                      key: 0,
                      class: "processing-loader"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.mapUrl)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "map",
                  style: _normalizeStyle('background-image: url(' + _ctx.mapUrl + ')')
                }, [
                  _createVNode(_component_md_button, {
                    variant: "elevated",
                    icon: "map",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openInMaps()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Karte")
                    ]),
                    _: 1
                  })
                ], 4))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: "overview",
              style: _normalizeStyle(_ctx.mapUrl && 'margin: -120px 0 0 0;')
            }, [
              (
              _ctx.conversation.dialog_id !== 'pweanJ3jyCovWPZkJKrN' &&
              _ctx.conversation.dialog_id !== 'joqW6y3lKR8Tus72D56x'
            )
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "image",
                    style: _normalizeStyle({
              backgroundImage: `url(${_ctx.conversation.photoURL || _ctx.WhatsAppLogo})`,
            })
                  }, null, 4))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.displayName) = $event)),
                placeholder: "Name",
                type: "text",
                class: "display-name",
                onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateDisplayName()))
              }, null, 544), [
                [_vModelText, _ctx.displayName]
              ]),
              _createElementVNode("h3", null, _toDisplayString(_ctx.conversation.variables?.email || _ctx.conversation.variables?.phone), 1),
              (
              _ctx.conversation.dialog_id === 'pweanJ3jyCovWPZkJKrN' &&
              _ctx.conversation?.variables
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("span", null, _toDisplayString(_ctx.getValueIndex(
                  _ctx.conversation.variables,
                  "30_bestellung.30_bestellung.30_bestellung.30_bestellung.30_bestellung.30_bestellung.30_bestellung.30_bestellung.30_bestellung.anzahl_gesamt"
                ) || "/"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _hoisted_9,
                      _createElementVNode("span", null, _toDisplayString(_ctx.getValueIndex(
                  _ctx.conversation.variables,
                  "01_kontaktinfos.kundengruppe"
                ) || "/"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("span", null, _toDisplayString(_ctx.getValueIndex(
                  _ctx.conversation.variables,
                  "30_bestellung.30_bestellung.30_bestellung.30_bestellung.30_bestellung.30_bestellung.30_bestellung.30_bestellung.30_bestellung.wunschlieferdatum"
                ) || "/"), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_12,
              _createVNode(_component_details_tags, { conversation: _ctx.conversation }, null, 8, ["conversation"]),
              _createVNode(_component_md_content_editable, {
                class: "notes",
                modelValue: _ctx.notes,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.notes) = $event)),
                text: _ctx.notes,
                "onUpdate:text": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.notes) = $event)),
                rows: 4,
                multiline: true,
                error: false,
                label: "Notizen",
                onBlur: _ctx.onNotesChange
              }, null, 8, ["modelValue", "text", "onBlur"])
            ], 4)
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (section, k) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["section", { active: _ctx.activeSection === section.id }]),
                key: k
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["section-header", { active: _ctx.activeSection === section.id }]),
                  onClick: ($event: any) => (_ctx.toggleSection(section))
                }, [
                  _createElementVNode("h4", null, _toDisplayString(section.name), 1),
                  _createVNode(_component_md_button, {
                    variant: "icon",
                    grey: "",
                    mode: "icon_small",
                    icon: "keyboard_arrow_down"
                  })
                ], 10, _hoisted_14),
                (_ctx.activeSection === section.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.fields, (field, n) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "section-input-wrapper",
                          key: n
                        }, [
                          (field.type === 'text' || field.type === 'number')
                            ? (_openBlock(), _createBlock(_component_md_input_field, {
                                key: 0,
                                modelValue: field.value,
                                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                label: field.label,
                                size: "small",
                                error: false,
                                onKeydown: ($event: any) => (_ctx.onFieldChange(field)),
                                onPaste: ($event: any) => (_ctx.onFieldChange(field)),
                                onChange: ($event: any) => (_ctx.onFieldChange(field)),
                                onBlur: ($event: any) => (_ctx.onFieldChange(field)),
                                onFocus: ($event: any) => (_ctx.onFieldFocus(field))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onKeydown", "onPaste", "onChange", "onBlur", "onFocus"]))
                            : _createCommentVNode("", true),
                          (field.type === 'boolean')
                            ? (_openBlock(), _createBlock(_component_md_checkbox, {
                                key: 1,
                                modelValue: field.value,
                                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                onChange: ($event: any) => (_ctx.onFieldChange(field))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(field.label), 1)
                                ]),
                                _: 2
                              }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"]))
                            : _createCommentVNode("", true),
                          (field.type === 'select')
                            ? (_openBlock(), _createBlock(_component_md_select, {
                                key: 2,
                                modelValue: field.value,
                                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                label: field.label,
                                variant: "outlined",
                                size: "small",
                                error: false,
                                onChange: ($event: any) => (_ctx.onFieldChange(field)),
                                items: 
                  field.values
                    ? field.values.map((value) => {
                        return {
                          label: value,
                          value: value,
                        };
                      })
                    : []
                
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onChange", "items"]))
                            : _createCommentVNode("", true),
                          (field.type === 'link')
                            ? (_openBlock(), _createBlock(_component_details_link_field, {
                                key: 3,
                                label: field.label,
                                modelValue: field.value,
                                "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                                onChange: ($event: any) => (_ctx.onFieldChange(field))
                              }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "onChange"]))
                            : _createCommentVNode("", true),
                          (field.type === 'file')
                            ? (_openBlock(), _createBlock(_component_details_file_field, {
                                key: 4,
                                field: field
                              }, null, 8, ["field"]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ])
        ], 64))
      : _createCommentVNode("", true)
  ])), [
    [_directive_v_on_click_outside, _ctx.onClickOutside]
  ])
}